import { createEvent, restore, sample } from 'effector'
import { $params } from '../../../../../features/router'
import {
  RangeValue,
  TransactionsDetailsItemFromServer,
  TransactionsDetailsResponse,
} from '../TransactionsDetails/types'
import { changedDateFormat } from '../../../../../libs/utils'
import { fx } from '../../../../../libs'
import { TransactionsDetailsRequest } from './types'

export const FilterEvent = createEvent<TransactionsDetailsRequest>()

export const getTransactionsDetails = fx<void, TransactionsDetailsResponse>({
  method: 'GET',
  url: '/finance/wallet/{walletID}/transaction',
})

export const $transactionsDetails = restore<
  TransactionsDetailsItemFromServer[]
>(
  getTransactionsDetails.doneData.map((a) => a.body.items),
  [],
)

sample({
  // @ts-ignore
  clock: FilterEvent,
  source: $params,
  fn: (params, { filters }) => {
    let filtersTransactionsParams = {}

    let query = {}

    // @ts-ignore
    query['order'] = `-createdAt`
    // @ts-ignore
    query['limit'] = `-1`

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency' || key === 'wallets' || key === 'type') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              if ((filters[key as keyof typeof filters] as RangeValue)[0]) {
                accumulator['dateFrom'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0],
                )
              }
              if ((filters[key as keyof typeof filters] as RangeValue)[1]) {
                accumulator['dateTo'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1],
                )
              }
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }


    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    }

    return {
      url: `/finance/all_transaction`,
      query,
    }
  },
  target: getTransactionsDetails,
})
